import { memo, useRef, useState } from "react";
import EventHeaderEditModal from "./EventHeaderEditModal";
import "../../Campaigns/Campaigns.css";

const EventCabec = ({
    state,
    setState,
    handleChangeInputs,
    handlerSubmitFormEvent,
    setActiveTab,
    handlerShowMusicGenres,
    handlerChangeImage
}) => {
    const [showEditModal, setShowEditModal] = useState(false);

    const seriaizeVenues = () => {
        if (
            state.generalInfo &&
            state.generalInfo.venues &&
            state.generalInfo.venues.length > 0
        )
            return state.generalInfo.venues.map((item) => {
                return {
                    label: item.name,
                    value: item.id,
                };
            });
    };

    const getVenueName = () => {
        if (state.generalInfo && state.generalInfo.venues) {
            const venue = state.generalInfo.venues.find(v => v.id == state.form.id_venues);
            return venue ? venue.name : "Sem local definido";
        }
        return "Sem local definido";
    }

    const handleChangeEventStatus = (status) => {
        setState((prevState) => {
            const newState = {
                ...prevState,
                form: {
                    ...prevState.form,
                    status: status,
                }
            };
            handlerSubmitFormEvent(newState);
            return newState;
        });
    };

    const handlerListPromotersEvent = () => {
        setState({
            ...state,
            modalGuestlistPromoters: {
                ...state.modalGuestlistPromoters,
                show: true,
            },
        });
    };

    const handlerEditLocationEvent = () => {
        setState({
            ...state,
            modalFormLocation: {
                ...state.modalFormLocation,
                show: true,
            },
        });
    }

    const countSelectedGenres = () => {
        if (!state.form.music_genre) return 0;
        return state.form.music_genre.length;
    };

    const StatusBox = memo(({ status }) => {
        const getStatusStyles = (txt) => {
            switch (txt) {
                case 'ACTIVE':
                    return { label: 'Publicado', class: 'status-active' };
                case 'DRAFT':
                    return { label: 'Rascunho', class: 'status-scheduled' };
                case 'CANCELED':
                    return { label: 'Cancelado', class: 'status-expired' };
                default:
                    return { label: txt, class: '' };
            }
        }

        const current = getStatusStyles(status);

        return (
            <div className="dropdown w-100">
                <div
                    data-bs-toggle="dropdown"
                    className={`campaign-status ${current.class} cursor-pointer w-100 justify-content-center py-2 dropdown-toggle border-0`}
                    style={{ borderRadius: '12px' }}
                >
                    <i className={`fa-solid ${status === 'ACTIVE' ? 'fa-circle-check' : status === 'DRAFT' ? 'fa-pen-to-square' : 'fa-circle-xmark'} me-1`}></i>
                    {current.label}
                </div>
                <ul className="dropdown-menu dropdown-menu-dark border-0 shadow-lg blur-glass no-scroll">
                    <li className={`${state.form.status === "DRAFT" ? 'd-block' : 'd-none'}`}>
                        <div onClick={() => handleChangeEventStatus("ACTIVE")} className="dropdown-item py-2 cursor-pointer text-success" >
                            <i className="fa-solid fa-cloud-arrow-up me-2"></i> PUBLICAR AGORA
                        </div>
                    </li>
                    <li className={`${state.form.status === "ACTIVE" ? 'd-block' : 'd-none'}`}>
                        <div onClick={() => handleChangeEventStatus("DRAFT")} className="dropdown-item py-2 cursor-pointer text-warning" >
                            <i className="fa-solid fa-file-export me-2"></i> VOLTAR A RASCUNHO
                        </div>
                    </li>
                    <li className={`${state.form.status === "ACTIVE" ? 'd-block' : 'd-none'}`}>
                        <hr className="dropdown-divider border-white border-opacity-10" />
                        <div onClick={() => handleChangeEventStatus("CANCELED")} className="dropdown-item py-2 cursor-pointer text-danger font-weight-bold" >
                            <i className="fa-solid fa-ban me-2"></i> CANCELAR EVENTO
                        </div>
                    </li>
                </ul>
            </div>
        )
    })

    return (
        <>
            <div className="campaign-card glass-glow border-0 mb-3 py-3 px-4 overflow-visible" style={{ height: 'auto' }}>
                <div className="d-flex gap-4 align-items-start">
                    {/* Left: Event Image (Fixed Size) */}
                    <div style={{ width: '140px', flexShrink: 0 }}>
                        <div
                            className="position-relative rounded-4 overflow-hidden border border-white border-opacity-10 shadow-sm"
                            style={{ paddingTop: '100%', background: `url(${state.form.event_image_url || 'https://via.placeholder.com/400x400?text=No+Image'}) center/cover no-repeat` }}
                        >
                            <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-25"></div>
                        </div>
                    </div>

                    {/* Right: Content & Actions */}
                    <div className="flex-grow-1 d-flex flex-column gap-2">
                        {/* Top: Title & Status */}
                        <div className="d-flex justify-content-between align-items-start">
                            <div className="flex-grow-1">
                                <h2 className="text-white fw-bold mb-1 fs-3">{state.form.name || "Sem Nome"}</h2>
                                <div className="d-flex align-items-center text-white-50 gap-3 small flex-wrap">
                                    <span className="d-flex align-items-center gap-2">
                                        <i className="fa-solid fa-location-dot text-primary"></i>
                                        {getVenueName()}
                                    </span>
                                    <span className="d-flex align-items-center gap-2">
                                        <i className="fa-regular fa-calendar text-primary"></i>
                                        {state.form.date} • {state.form.hour_start} - {state.form.hour_end}
                                    </span>
                                </div>
                            </div>
                            <div style={{ width: '160px' }}>
                                <StatusBox status={state.form.status} />
                            </div>
                        </div>

                        {/* Description */}
                        {state.form.description && (
                            <p className="text-muted small mb-1 line-clamp-2" style={{ maxWidth: '90%' }}>
                                {state.form.description}
                            </p>
                        )}

                        {/* Bottom: Actions */}
                        <div className="d-flex align-items-center gap-2 mt-auto pt-2">
                            <button
                                className="btn-action glass-glow btn-campaign-secondary py-1 px-3 rounded-pill shadow-sm border-0 d-flex align-items-center gap-2"
                                onClick={() => setShowEditModal(true)}
                                style={{ height: '34px' }}
                            >
                                <i className="fa-solid fa-pen-to-square small"></i>
                                <span className="fw-bold small">Editar Detalhes</span>
                            </button>

                            <div className="vr mx-2 bg-white opacity-10"></div>

                            <button
                                className="btn-action btn-campaign-secondary py-1 px-3 rounded-pill border-0 small text-xs d-flex align-items-center gap-2"
                                onClick={handlerListPromotersEvent}
                                style={{ height: '32px' }}
                            >
                                <i className="fa-solid fa-users"></i> <span>Promotores</span>
                            </button>

                            <button
                                className="btn-action btn-campaign-secondary py-1 px-3 rounded-pill border-0 small text-xs d-flex align-items-center gap-2"
                                onClick={handlerEditLocationEvent}
                                style={{ height: '32px' }}
                            >
                                <i className="fa-solid fa-map-pin"></i> <span>Local</span>
                            </button>

                            <button
                                className="btn-action btn-campaign-secondary py-1 px-3 rounded-pill border-0 small text-xs d-flex align-items-center gap-2"
                                onClick={() => handlerShowMusicGenres(true)}
                                style={{ height: '32px' }}
                            >
                                <i className="fa-solid fa-music"></i>
                                <span>{countSelectedGenres() > 0 ? `${countSelectedGenres()} Gén.` : 'Géneros'}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <EventHeaderEditModal
                show={showEditModal}
                onHide={() => setShowEditModal(false)}
                state={state}
                handleChangeInputs={handleChangeInputs}
                handlerChangeImage={handlerChangeImage}
                handlerSubmitFormEvent={handlerSubmitFormEvent}
                seriaizeVenues={seriaizeVenues}
            />
        </>
    );
};

export default memo(EventCabec);
